// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionBackfill_RunInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /cli/subscription_backfill/run
 *
 * Triggers the cutover grace-for-all backfill.
 * Protected by X-Internal-Token — no user JWT required.
 */
import { registerContract } from './validate'

export interface SubscriptionBackfill_RunInput {
days?: number
}

registerContract('SubscriptionBackfill_RunInput', {
  days: { type: 'number',  required: false },
})
